import React from 'react'
import { ReactComponent as Usa } from 'assets/icons/flags/Usa.svg'
import { ReactComponent as Uk } from 'assets/icons/flags/UK.svg'
import { ReactComponent as Germany } from 'assets/icons/flags/DE.svg'
import { ReactComponent as Ireland } from 'assets/icons/flags/Ireland.svg'
import { ReactComponent as Canada } from 'assets/icons/flags/Canada.svg'
import { ReactComponent as Australia } from 'assets/icons/flags/Australia.svg'
import { ReactComponent as NewZealand } from 'assets/icons/flags/NewZealand.svg'
import { ReactComponent as SouthKorea } from 'assets/icons/flags/southKorea.svg'
import { ReactComponent as Japan } from 'assets/icons/flags/japan.svg'
import { ReactComponent as Malaysia } from 'assets/icons/flags/malaysia.svg'
import { ReactComponent as Indonesia } from 'assets/icons/flags/indonesia.svg'
import { ReactComponent as Singapore } from 'assets/icons/flags/singapore.svg'
import { ReactComponent as Vietnam } from 'assets/icons/flags/vietnam.svg'
import { ReactComponent as Uae } from 'assets/icons/flags/UAE.svg'
import { ReactComponent as SaudiArabia } from 'assets/icons/flags/saudiArabia.svg'
import { ReactComponent as Planet } from 'assets/icons/flags/planet.svg'

/**
 * Country name → flag icon. Keys match Student `countryIcons` in
 * kandor-frontend AiToolNew/dataConstants.js.
 */
export const COUNTRY_FLAG_ICONS = {
	USA: Usa,
	UK: Uk,
	Germany,
	Australia,
	'New Zealand': NewZealand,
	Ireland,
	Canada,
	'South Korea': SouthKorea,
	Japan,
	Malaysia,
	Indonesia,
	Singapore,
	Vietnam,
	'Saudi Arabia': SaudiArabia,
	UAE: Uae,
	'United Arab Emirates': Uae,
}

/** Countries in Student countryIcons with no SVG in assets/icons/flags yet. */
export const MISSING_COUNTRY_FLAG_KEYS = []

export function CountryFlagIcon({ country, className }) {
	const Icon = COUNTRY_FLAG_ICONS[country] || Planet
	return <Icon className={className} aria-hidden focusable="false" />
}
